var React = require('react');

function IcChevronLeft24px (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}));
}

IcChevronLeft24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcChevronLeft24px;

IcChevronLeft24px.default = IcChevronLeft24px;
